import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../../services/authContext/utils'

const Logout: React.FC = () => {
  const { isAuthenticated, logoutFromSystem } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (isAuthenticated) {
      logoutFromSystem()
      navigate('/login')
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated])
  return (
    <>
      <h1>Logging out...</h1>
    </>
  )
}

export default Logout
